import 'twin.macro';
import { useNavMenus } from '@/utils/hooks/useMenus';

import Styles from './HeaderContainer.module.scss';
import CrossSellHeader from '../CrossSellHeader/CrossSellHeader';
import MainNavigation from '../MainNavigation/MainNavigation';
import MobileContainer from '../MobileContainer/MobileContainer';

const HeaderContainer = ({ sport }:{ sport?:string }) => {
  const { menuData, isLoading } = useNavMenus();
  const topNav = menuData.header;
  const contentNav = menuData?.['Research Menu'];
  const mobile = menuData?.['Research Mobile'];

  if (isLoading) {
    return <div />;
  }

  return (
    <>
      <div className={Styles.placeholder} />
      <div className={Styles.container}>
        <div className={Styles.scrollContainer}>
          <CrossSellHeader menuItems={(topNav?.menuItems ?? [])} />
        </div>
        <div className={Styles.researchNav}>
          <MainNavigation sport={sport} menuItems={contentNav?.menuItems ?? []} />
          <MobileContainer menuItems={mobile?.menuItems ?? []} />
        </div>
      </div>
    </>
  );
};
export default HeaderContainer;
